<template>
  <div>
    <el-form :model="data.lastNode" ref="pstRef" status-icon label-width="80px">
      <el-form-item label="办理方式">
        <el-radio-group v-model="data.form.selectType">
          <el-radio :label="1">工单转办</el-radio>
          <el-radio :label="-1" :disabled="data.pst.pstType == 0 && data.pst.status == 0">{{
            data.pst.status == 0
              ? "撤销重审"
              : data.pst.status == 3
                ? "撤销重办"
                : ""
          }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="转办单位">
        <el-select transfer="true" :disabled="data.form.selectType != 1" v-model="data.form.transferUnitId"
          placeholder="请选择单位" filterable popper-append-to-body>
          <el-option v-for="unit in data.units" :key="unit.id" :label="unit.name" :value="unit.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="转办留言">
        <el-input type="textarea" :rows="3" v-model="data.form.message" :disabled="data.lastNode.isSucces" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "GDanTransfer",
  props: ["pstId"],
  created() {
    this.data.pst.id = this.pstId;
    this.data.user = this.pstApi.getUserData();
    this.getUnits(); //读取所有单位信息
    this.getPst(); //读取留言信息
  },
  data() {
    return {
      tabPosition: "right",
      tabIndex: 0,
      activeTabName: "tabLast",
      //数据项
      data: {
        user: "",
        statusName: "",
        pstTypeName: "",
        units: [], //单位数据
        pst: {
          id: "",
        },
        nodes: [],
        //转办数据
        lastNode: {
          id: "",
          isSucces: false,
          lastTime: "",
          nodeContent: "",
          nodeMessage: "",
          pstId: "",
          pstType: 0,
          status: 1,
          transferUnitId: "",
          transferUnitName: "",
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          uploadCount: 0,
        },
        // transferNode:"",
        form: {
          selectType: 1,
          transferUnitId: "",
          message: "",
        },
      },
    };
  },
  methods: {
    getUnits() {
      this.data.units = [];
      this.userApi.getUnitAll().then((res) => {
        var data = res.data;
        this.data.units = this.data.units.concat(data);
      });
    },
    getPst() {
      this.pstApi
        .getPstInfo(this.data.pst.id)
        .then((res) => {
          var data = res.data;
          //console.log(data);
          this.data.pst = data;
          //
          var transferNodes = data.nodeInfos.filter(
            (node) => node.isSucces == false
          );
          if (transferNodes.length > 0) {
            this.data.lastNode = transferNodes[0];
          }
          this.data.form.selectType = this.data.lastNode.status;
          this.data.form.transferUnitId = this.data.lastNode.transferUnitId;
          this.data.form.message = this.data.lastNode.nodeMessage;
          //
          this.data.lastNode.unitId = this.data.user.unitId;
          this.data.lastNode.unitName = this.data.user.unitName;
          this.data.lastNode.userId = this.data.user.userId;
          this.data.lastNode.userName = this.data.user.name;

          this.data.nodes = data.nodeInfos.filter(
            (node) => node.isSucces == true
          );
          this.data.statusName = this.pstApi.getStatusTransferTitle(
            data.status
          );
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
        })
        .catch(() => {
          this.$toast("读取失败");
        });
    },
    formSubmit(buttonType) {
      let pstId = this.data.pst.id;
      let selectType = this.data.form.selectType;
      var message = this.data.form.message;
      var transferUnId = "00000000-0000-0000-0000-000000000000";
      if (selectType == 1 && this.data.form.transferUnitId != "") {
        transferUnId = this.data.form.transferUnitId;
      }
      var submitType = 0;
      if (buttonType == 1) {
        submitType = this.data.form.selectType;
      }

      if (pstId == "" || (transferUnId == "" && submitType == 1)) {
        this.$toast("请填写转办单位");
        return;
      }
      if (message == "") {
        if (selectType == 1) {
          message = "请办理";
        } else if (selectType == -1 && this.data.pst.status == 0) {
          message = "请重新审核";
        } else if (selectType == -1 && this.data.pst.status == 3) {
          message = "请继续办理";
        }
      }

      this.pstApi
        .newPstTransfer(pstId, transferUnId, message, submitType)
        .then((res) => {
          if (submitType == 1) {
            this.$toast("提交成功");
          } else if (submitType == 0) {
            this.$toast("保存成功");
            this.getPst();
          } else {
            this.$toast("撤销重审成功");
          }
          this.$emit("success");
        })
        .catch((err) => {
          this.$toast(err.response.data.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-radio {
  margin-right: 5px;
}

/deep/.el-select-dropdown {
  position: absolute;
  z-index: 99999;
}
</style>